import {useNavigate} from 'react-router-dom';
import {Activity} from 'APIs/letrusAPI/activities/types';

interface UseFocusModeRedirectParams {
  learningPath: Activity | undefined;
}

export default function useFocusModeRedirect({
  learningPath,
}: UseFocusModeRedirectParams) {
  const navigate = useNavigate();

  // Returns true if a Focus Mode redirect was triggered (caller should stop its flow)
  function handleFocusModeRedirect(): boolean {
    const focusModeStatus = learningPath?.focus_mode_status;

    if (
      !learningPath?.uses_focus_mode ||
      focusModeStatus == null ||
      focusModeStatus === 'in_progress'
    ) {
      return false;
    }

    if (focusModeStatus === 'not_started') {
      navigate('/');
      return true;
    }

    if (focusModeStatus === 'expired_composition') {
      navigate('/redacao-expirada');
      return true;
    }

    if (focusModeStatus === 'abandonment_rule_violated') {
      navigate('/abandono');
      return true;
    }

    const isExpiredOrFinished =
      learningPath?.status === 'expired' || learningPath?.status === 'finished';

    if (isExpiredOrFinished && learningPath?.feedback_released === false) {
      navigate('/revisao-pendente');
      return true;
    }

    return false;
  }

  return {handleFocusModeRedirect};
}
